import styled from 'styled-components';
import { UIText } from '../../typography';

export const ItemCardTimer = styled(UIText)`
  text-align: left;
`;
